import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCarlist, setJob, getActiveJob, setBids } from '../../redux/Actions';
import { Redirect } from 'react-router-dom';
import InlineSVG from 'svg-inline-react';
import Icons from '../icons/Icons';
import CarInput from '../carinput/CarInput';
import carColors from '../carinput/carColors';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import { store } from 'react-notifications-component';

import './Order.css';

export const parseJob = data => {
    let job = {
        job_type: '',
    };
    return job;
};

const getColor = (colorid) => {
    return carColors[carColors.findIndex(function(obj){return obj.id === colorid})].name;
}

const getMake = (state, makeid) => {
    return state.cars_list.carList[state.cars_list.carList.findIndex(function(obj){return obj.id === makeid})].name;
}

const getDescription = (job, state) => {
    let content = "";
    switch (job.job_type) {
        case 'house':
            content += "Number of locks - " + job.numberOfLocks;
            break;

        case 'car':
            content = 'Make: ' + getMake(state, job.make) + ',  Model: ' + job.model + ', Year: ' + job.year + ', Color: ' + getColor(job.color);
            break;

        case 'trunk':
            content = 'Make: ' + getMake(state, job.make) + ',  Model: ' + job.model + ', Year: ' + job.year + ', Color: ' + getColor(job.color) + "\n ";
            content += 'Trunk release: ' + job.trunklock;
            break;

        case 'storage':
            content = 'Storage Unit description: ' + state.job_description;
            break;

        case 'general':
            content = 'General Lockout description: ' + state.job_description;
            break;

        case 'changelocks':
            content = "Property type: " + job.residentialSwitch + ", \n";
            content += "Number of locks: " + job.numberOfLocks + ", \n";
            content += "Lock type: " + job.lockType;
            break;

        case 'rekey':
            content = "Property type: " + job.residentialSwitch + ", \n";
            content += "Number of locks: " + job.numberOfLocks + ", \n";
            content += "Lock type: " + job.lockType;
            break;

        case 'carkey':
            content = 'Make: ' + getMake(state, job.make) + ',  Model: ' + job.model + ', Year: ' + job.year + ', Color: ' + getColor(job.color)+ " \n";
            content += "Key type: " + job.keyType;
            break;

        case 'cardoor':
            content = 'Make: ' + getMake(state, job.make) + ',  Model: ' + job.model + ', Year: ' + job.year + ', Color: ' + getColor(job.color);
            break;

        case 'keyextraction':
            content = "Property type: " + job.residentialSwitch + ", \n";
            content += "Number of locks: " + job.numberOfLocks + ", \n";
            content += "Lock type: " + job.lockType;
            break;

        case 'key_extraction_from_car':
            content = 'Make: ' + getMake(state, job.make) + ',  Model: ' + job.model + ', Year: ' + job.year + ', Color: ' + getColor(job.color) + " \n";
            content += "Key type: " + job.ignDoorSwitch;
            break;

        case 'safe':
            content = "Lock type: " + job.safetype + " \n";
            content += 'Description: ' + state.job_description;
            break;

        case 'panic_bar':
            content = "Lock type: " + job.panicbar;
            break;

    }
    return content;
}

class Order extends Component {
    constructor(props) {
        super(props);
        this.state = {
            body_class: ['apps-gotlocked-order'],
            job: {
                job_type: '',
                image: '',
                make: '',
                model: '',
                year: '',
                color: '',
                description: '',
                address: {
                    address: '',
                    apartment: '',
                    location_lng: '',
                    location_lat: '',
                    city: '',
                    zip: '',
                    state: '',
                    additionalNote: '',
                    name: '',
                    firstname: '',
                    lastname:''
                },                
                payment_method: 'credit_card',
                payment_data: null,
                numberOfLocks: '',
                residentialSwitch: '',
                ignDoorSwitch: '',
                panicbar: '',
                safetype: '',
                lockType: '',
                keyType: '',
                trunklock: '',
            },
            job_description: "",           
            showModal: false,
            carinput: new CarInput(),
            type: '',
            modalTitle: '',
            modalContent: '',

            redirect: false,
            status_redirect: false,

            cars_list: {},
            make_list: [],
            model_list: [],
            year_list: [],

            model_key: null,

            make_ref: null,
            model_ref: null,
            year_ref: null,
            color_ref: null,
            trunklock_ref: null,
            number_of_locks_ref: null,
            input_number_ref: null,
            button_number_ref: null,
            carkeytype_ref: null,
            locktype_ref: null,
            keytype_ref: null,
            doorkeytype_ref: null,
            propertytype_ref: null,
            panicbar_ref: null,
            safetype_ref: null,
            descrtiption_ref: null,
            validate_list: [],
            loader: true,
        };
        this.props.setJob(null);
        this.props.setBids(null);
    }

    componentWillMount() {
        setTimeout(function() {
            if (document.body.classNameList) {
                document.body.classNameList.add(...this.state.body_class);
            } else {
                document.body.className = this.state.body_class.join(' ');
            }
            //document.getElementById('apps-gotlocked-menu').style.display = 'none';
        }.bind(this), 1);
        this.props.getCarlist();
        this.props.getActiveJob();
    }

    componentDidMount() {
        setTimeout(function() {
            if (this.props.active_job !== undefined && this.props.active_job !== null) {
                store.addNotification({
                    title: 'Active price request',
                    message: 'Active price request exist, redirecting to status page',
                    type: 'danger',
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 5000,
                      onScreen: true
                    }
                });

                this.setState({
                    status_redirect: true
                });
            }
            this.setState({
                loader: false
            });
        }.bind(this), 3000);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cars_list !== this.props.cars_list) {
            this.setState({
                cars_list: this.props.cars_list                
            });
        }    
    }

    gotoMap() {
        let error = this.state.carinput.validate(this);
        if (error === false) {
            this.state.job.description = getDescription(this.state.job, this.state);
            // this.setState(prevState => ({
            //     job: {
            //         ...prevState.job,
            //         description: getDescription(this.state.job, this.state)
            //     }
            // }));
            this.props.setJob(this.state.job);
            this.setState({
                redirect: true
            });
        }
    }

    emptyValues() {
        this.setState({
            job: {
                job_type: '',
                image: '',
                make: '',
                model: '',
                year: '',
                color: '',
                description: '',
                address: {
                    address: '',
                    apartment: '',
                    location_lng: '',
                    location_lat: '',
                    city: '',
                    zip: '',
                    state: '',
                    additionalNote: '',
                    name: '',
                    firstname: '',
                    lastname:''
                },                
                payment_method: 'credit_card',
                payment_data: null,
                numberOfLocks: '',
                residentialSwitch: '',
                ignDoorSwitch: '',
                panicbar: '',
                safetype: '',
                lockType: '',
                keyType: '',
                trunklock: '',
            },
            job_description: "",           
            type: '',
            modalTitle: '',
            modalContent: '',
        });
    }

    hideModal() {
        this.emptyValues();
        this.setState({ showModal: false });
    }

    updateImage(image) {
        if (image) {
            this.setState(prevState => ({
                job: {
                    ...prevState.job,
                    image: image
                }
            }));
        }
    }

    chnageColor(color) {
        if (color) {
            this.setState(prevState => ({
                job: {
                    ...prevState.job,
                    color: color.value
                }
            }));
        }
    }

    changeYear(year) {
        if (year) {
            this.setState(prevState => ({
                job: {
                    ...prevState.job,
                    year: year.value
                }
            }));
            if (this.state.color_ref) {
                this.state.color_ref.select.setValue(null);
                this.state.job.color = "";
            }
        }
    }

    changeModel(model) {
        if (model) {
            this.setState(prevState => ({
                job: {
                    ...prevState.job,
                    model: model.value
                },
            }));
            
            this.state.cars_list.carList.map((option, index) => {
                if (this.state.job.make === option.id) {
                    option.models.map((option2, index) => {
                        if (model.value === option2.id_name) {
                            this.state.year_list.length = 0;
                            let _year = [];
                            option2.years.map((option3, index) => {
                                // this.state.year_list.push({ value: option3, label: option3 });
                                _year.push({ value: option3, label: option3 });
                            });
                            // console.log('year', _year);
                            this.setState({
                                year_list: _year,
                                // showModal: false
                            });
                            setTimeout(function() {
                                this.setModalShow(this.state.type);
                            }.bind(this), 0);
                        }
                    });
                }
            });
            if (this.state.year_ref) {
                this.state.year_ref.select.setValue(null);
                this.state.job.year = "";
                this.state.color_ref.select.setValue(null);
                this.state.job.color = "";
            }
            //console.log('changeModel', this.state);
        }
    }

    changeMake(make) {
        this.setState(prevState => ({
            job: {
                ...prevState.job,
                make: make.value
            },
        }));
        this.state.cars_list.carList.map((option, index) => {
            if (make.value === option.id) {
                this.state.model_list.length = 0;
                let _model = [];
                option.models.map((option2, index) => {
                    _model.push({ value: option2.id_name, label: option2.name });
                    // this.state.model_list.push({ value: option2.id_name, label: option2.name });
                    // this.state.model_ref.select.props.options.push({ value: option2.id_name, label: option2.name });
                });
                // console.log('model', _model, this.state.model_ref.select);
                this.setState({
                    model_list: _model,
                    // showModal: false
                });
                setTimeout(function() {
                    this.setModalShow(this.state.type);
                }.bind(this), 0);
                // this.state.model_ref.select.props.options(_model);
            }
        });

        if (this.state.model_ref) {
            this.state.model_ref.select.setValue(null);
            this.state.job.model = "";            
            this.state.year_ref.select.setValue(null);
            this.state.job.year = "";
            this.state.color_ref.select.setValue(null);
            this.state.job.color = "";
            while(this.state.year_list.length > 0) {
                this.state.year_list.pop();
            }
        }
        //console.log('changeMake', this.state);
    }

    getMake() {
        if (this.state.cars_list) {
            this.state.cars_list.carList.map((option, index) => {
                this.state.make_list.push({ value: option.id, label: option.name });
            });
        }
        //console.log('getMake', this.state);
    }

    setModalShow(type) {
        //console.log('setModalShow with type: ' + type);
        this.getMake();
        this.setState(prevState => ({
            type: type,
            validate_list: [],
            job: {
                ...prevState.job,
                job_type: type
            }
        }));

        switch (type) {
            case 'car':
                this.setState({
                    modalTitle: 'Car Lockout',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)} {this.state.carinput.getMakeModel(this)}</Row>
                });
                break;

            case 'trunk':
                this.setState({
                    modalTitle: 'Trunk Lockout',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)}
                        <Col>
                            <Row>{this.state.carinput.getMakeModel(this)}</Row><Row>{this.state.carinput.getTrank(this)}</Row>
                        </Col>
                    </Row>
                });
                break;

            case 'house':
                this.setState({
                    modalTitle: 'House Lockout',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)} {this.state.carinput.getLocks(this)}</Row>
                });
                break;

            case 'storage':
                this.setState({
                    modalTitle: 'Storage Unit Lockout',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)} {this.state.carinput.getDescription(this)}</Row>
                });
                break;

            case 'general':
                this.setState({
                    modalTitle: 'General Lockout',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)} {this.state.carinput.getDescription(this)}</Row>
                });
                break;

            case 'changelocks':
                this.setState({
                    modalTitle: 'Change Locks',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)}
                        <Col>
                            <Row>{this.state.carinput.getPropertyType(this)}</Row>
                            <Row>{this.state.carinput.getLocks(this)}</Row>
                            <Row>{this.state.carinput.getLockType(this)}</Row>
                        </Col>
                    </Row>
                });
                break;

            case 'rekey':
                this.setState({
                    modalTitle: 'Rekey',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)}
                        <Col>
                            <Row>{this.state.carinput.getPropertyType(this)}</Row>
                            <Row>{this.state.carinput.getLocks(this)}</Row>
                            <Row>{this.state.carinput.getLockType(this)}</Row>
                        </Col>
                    </Row>
                });
                break;

            case 'carkey':
                this.setState({
                    modalTitle: 'Car Key',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)}
                        <Col>
                            <Row>{this.state.carinput.getMakeModel(this)}</Row>
                            <Row>{this.state.carinput.carKeyType(this)}</Row>
                        </Col>
                    </Row>
                });
                break;

            case 'cardoor':
                this.setState({
                    modalTitle: 'Change Car Door Locks',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)} {this.state.carinput.getMakeModel(this)}</Row>
                });
                break;

            case 'keyextraction':
                this.setState({
                    modalTitle: 'Key Extraction',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)}
                        <Col>
                            <Row>{this.state.carinput.getPropertyType(this)}</Row>
                            <Row>{this.state.carinput.getLocks(this)}</Row>
                            <Row>{this.state.carinput.getLockType(this)}</Row>
                        </Col>
                    </Row>
                });
                break;

            case 'key_extraction_from_car':
                this.setState({
                    modalTitle: 'Key Extraction From Car',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)}
                        <Col>
                            <Row>{this.state.carinput.getMakeModel(this)}</Row>
                            <Row>{this.state.carinput.getKeyExtract(this)}</Row>
                        </Col>
                    </Row>
                });
                break;

            case 'safe':
                this.setState({
                    modalTitle: 'Safe',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)}
                        <Col>
                            <Row>{this.state.carinput.getSafeType(this)}</Row>
                            <Row>{this.state.carinput.getDescription(this)}</Row>
                        </Col>
                    </Row>
                });
                break;

            case 'panic_bar':
                this.setState({
                    modalTitle: 'Panic Bar (Push Bar)',
                    modalContent: <Row>{this.state.carinput.getAddImage(this)} {this.state.carinput.getPanicBar(this)}</Row>
                });
                break;

        }
        this.setState({ showModal: true });
    }

    render() {
        //console.log(this.props, this.state);
        var icons = new Icons();
        if (this.state.redirect) {
            return (<Redirect push to='/map' />);
        }
        if (this.state.status_redirect) {
            return (<Redirect push to='/status' />);
        }
        return (
            <div>
                <Loader
                    type="Watch"
                    color="#fcae4b"
                    height={100}
                    width={100}
                    visible={this.state.loader}
                    className="loader"
                     />
                <div className="apps-gotlocked-video-bg-section"></div>
                <section className="apps-gotlocked-order-section" id="apps-gotlocked-order">
                    <div className="apps-gotlocked-order-container">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="apps-gotlocked-welcome-tbl">
                                        <div className="apps-gotlocked-order-tbl-c">
                                            <div className="apps-gotlocked-order-content text-center">
                                                <h1>Type of Service</h1>
                                            </div>
                                        </div>
                                        <div className="apps-gotlocked-buttons">
                                            <Row className="justify-content-center">
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('car')}>
                                                        <InlineSVG src={icons.getIcon('carLockout')} />
                                                        <p>Car Lockout</p>
                                                    </Button>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('trunk')}>
                                                        <InlineSVG src={icons.getIcon('trunkLockout')} />
                                                        <p>Trunk Lockout</p>
                                                    </Button>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('house')}>
                                                        <InlineSVG src={icons.getIcon('houseLockout')} />
                                                        <p>House Lockout</p>
                                                    </Button>
                                                </Col>
                                            </Row>

                                            <Row className="justify-content-center">
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('storage')}>
                                                        <InlineSVG src={icons.getIcon('storageUnitLockout')} />
                                                        <p>Storage Unit <br />Lockout</p>
                                                    </Button>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('general')}>
                                                        <InlineSVG src={icons.getIcon('lockoutGeneral')} />
                                                        <p>Lockout General</p>
                                                    </Button>
                                                </Col>
                                            </Row>

                                            <Row className="justify-content-center">
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('changelocks')}>
                                                        <InlineSVG src={icons.getIcon('changeLocks')} />
                                                        <p>Change Locks</p>
                                                    </Button>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('rekey')}>
                                                        <InlineSVG src={icons.getIcon('rekey')} />
                                                        <p>Rekey</p>
                                                    </Button>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('carkey')}>
                                                        <InlineSVG src={icons.getIcon('carKey')} />
                                                        <p>Car Key</p>
                                                    </Button>
                                                </Col>
                                            </Row>

                                            <Row className="justify-content-center">
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('cardoor')}>
                                                        <InlineSVG src={icons.getIcon('changeCarDoor')} />
                                                        <p>Change Car Door Locks</p>
                                                    </Button>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('keyextraction')}>
                                                        <InlineSVG src={icons.getIcon('keyExtraction')} />
                                                        <p>Key Extraction</p>
                                                    </Button>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('key_extraction_from_car')}>
                                                        <InlineSVG src={icons.getIcon('keyExtractionFromCar')} />
                                                        <p>Key Extraction From Car</p>
                                                    </Button>
                                                </Col>
                                            </Row>

                                            <Row className="justify-content-center">
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('safe')}>
                                                        <InlineSVG src={icons.getIcon('safe')} />
                                                        <p>Safe</p>
                                                    </Button>
                                                </Col>
                                                <Col xs={6} md={3}>
                                                    <Button variant="outline-dark" onClick={() => this.setModalShow('panic_bar')}>
                                                        <InlineSVG src={icons.getIcon('panicBar')} />
                                                        <p>Panic Bar<br />(Push Bar)</p>
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal size="lg" show={this.state.showModal} aria-labelledby="contained-modal-title-vcenter" centered onHide={() => this.hideModal()}>
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {this.state.modalTitle}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.modalContent}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.hideModal()} variant="secondary">Close</Button>
                        <Button variant="success" onClick={() => this.gotoMap()}>Choose Location</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    //console.log('mapStateToProps', state);
    const { job, cars_list, active_job } = state;
    return { cars_list, job, active_job };
};

export default connect(mapStateToProps, { getCarlist, setJob, getActiveJob, setBids })(Order);